<template>
  <UserLogin />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UserLogin from "@/components/UserLogin.vue";

export default defineComponent({
  name: "LoginView",
  components: {
    UserLogin,
  },
});
</script>
